import { render, staticRenderFns } from "./SetName.vue?vue&type=template&id=61824cea&scoped=true&"
import script from "./SetName.vue?vue&type=script&lang=ts&"
export * from "./SetName.vue?vue&type=script&lang=ts&"
import style0 from "./SetName.vue?vue&type=style&index=0&id=61824cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61824cea",
  null
  
)

export default component.exports